import routes from './children/index';
let route = [{
  path: '/document',
  name: 'document',
  component: () => import( /* webpackChunkName: "about" */ '@/views/document/Document.vue'),
  meta: {
    bodyColor: '#fff'
  },
  children: [
    ...routes
  ]
}]

export default route;